// External libraries
import styled from '@emotion/styled';

// Internal Modules
import { TEXT_COLOR } from '@/styles/styleVariables';
import { bodyStyles } from '@/styles/fontRebrandingStyles';

const AccessibilityText = styled.span`
  left: -9999px;
  opacity: 0;
  position: absolute;
`;

type StyledTextProps = {
  fontSize?: string;
  fontWeight?: number;
};

const StyledText = styled.p<StyledTextProps>`
  color: ${TEXT_COLOR};
  font-size: ${({ fontSize }) => fontSize || '13px'};
  font-weight: ${({ fontWeight }) => fontWeight};
  line-height: 1.38;

  .overrides-font-4-2 & {
    ${bodyStyles}
  }
`;

export { AccessibilityText, StyledText };
